import { shareApi } from 'app/services/api';
import { ListResponse } from 'app/types';

export const upload = shareApi.injectEndpoints({
  endpoints: (build) => {
    return {
      uploadFile: build.mutation({
        query: (formData: FormData) => {
          return {
            url: `${process.env.REACT_APP_API_V1_VERSION}/upload/multiple/file`,
            method: 'POST',
            body: formData
          };
        }
      }),
      createDocument: build.mutation({
        query: (data: { files: Array<any>; path: string }) => {
          return {
            url: `${process.env.REACT_APP_API_V1_VERSION}/micro/document-list`,
            method: 'POST',
            body: data
          };
        }
      }),
      getDocument: build.query({
        query: (id: string) => {
          return {
            url: `${process.env.REACT_APP_API_V1_VERSION}/micro/document-list/${id}`,
            method: 'GET'
          };
        }
      })
    };
  }
});

export const sharedApi = shareApi.injectEndpoints({
  endpoints: (build) => {
    return {
      getLocations: build.query<
        {
          data: Array<any>;
          pagination: {
            page: number;
            pageSize: number;
            pages: number;
            total: number;
          };
        },
        {
          current: number;
          pageSize: number;
          searchBy?: string;
          keywords?: string;
        }
      >({
        query: () => {
          return {
            url: `${process.env.REACT_APP_API_V2_VERSION}/areas/countries`,
            method: 'GET',

            transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
              return {
                pagination: baseQueryReturnValue.data.pagination,
                data: baseQueryReturnValue.data
              };
            }
          };
        }
      })
    };
  }
});
export const {
  useUploadFileMutation,
  useCreateDocumentMutation,
  useLazyGetDocumentQuery
} = upload;

export const { useGetLocationsQuery, useLazyGetLocationsQuery } = sharedApi;
